<script>
    export default {
        computed: {
            currentAssetType() { return this.$store.getters.CURRENT_ASSET_TYPE },
            currentProvider() { return this.$store.getters.CURRENT_PROVIDER },
            currentGame() { return this.$store.getters.CURRENT_GAME },
            currentFileStatus() { return this.$store.getters.CURRENT_FILE_STATUS },
            currentAdditionalStatus() { return this.$store.getters.CURRENT_ADDITIONAL_STATUS },
            providers() { return this.$store.getters.PROVIDERS },
            games() { return this.$store.getters.GAME_BY_PROVIDER_ID(Number(this.currentProvider)) },
            assetTypes() { return this.$store.getters.ASSET_TYPES },
            fileStatus() { return this.$store.getters.FILE_STATUS },
            additionalStatus() { return this.$store.getters.ADDITIONAL_STATUS },
        },
        methods: {
            async changeFileStatus(event) {
                this.$store.commit('CURRENT_FILE_STATUS', event.target.value);
            },
            async changeAdditionalStatis(event) {
                this.$store.commit('CURRENT_ADDITIONAL_STATUS', event.target.value);
            },
            async changeAssetType(event) {
                this.$store.commit('CURRENT_ASSET_TYPE', event.target.value);
            },
            async changeProvider(event) {
                this.$store.commit('CURRENT_PROVIDER', event.target.value);
                this.$store.commit('CURRENT_GAME', this.$store.getters.DEFAULT_GAME);
            },
            async changeGame(event) {
                this.$store.commit('CURRENT_GAME', event.target.value);
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <div class="table_row">
            <div class="cell_label">
                <label>File Status:</label>
            </div>
            <div class="cell_container">
                <select 
                    :value="currentFileStatus"
                    @change="changeFileStatus"
                >
                    <option value="all">All</option>
                    <option
                        v-for="(fileStatusValue, fileStatusIndex) in fileStatus" :key="fileStatusIndex"
                        :value="fileStatusValue.id"
                    >
                        {{ fileStatusValue.name }}
                    </option>
                </select>
            </div>
            <div class="cell_label">
                <label>Additional Status:</label>
            </div>
            <div class="cell_container">
                <select 
                    :value="currentAdditionalStatus"
                    @change="changeAdditionalStatis"    
                >
                    <option value="all">All</option>
                    <option
                        v-for="(additionalValue, additionalIndex) in additionalStatus" :key="additionalIndex"
                        :value="additionalValue.id"
                    >
                        {{ additionalValue.name }}
                    </option>
                </select>
            </div>
            <div class="cell_label">
                <label>Asset Type:</label>
            </div>
            <div class="cell_container">
                <select 
                    :value="currentAssetType"
                    @change="changeAssetType"    
                >
                    <option value="all">All</option>
                    <option
                        v-for="(assetTypeValue, assetTypeIndex) in assetTypes" :key="assetTypeIndex"
                        :value="assetTypeValue.id"
                    >
                        {{ assetTypeValue.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="table_row">
            <div class="cell_label">
                <label>Provider:</label>
            </div>
            <div class="cell_container">
                <select 
                    :value="currentProvider"
                    @change="changeProvider"    
                >
                    <option value="all">All</option>
                    <option
                        v-for="(providerValue, providerindex) in providers" :key="providerindex"
                        :value="providerValue.id"
                    >
                        {{ providerValue.name }}
                    </option>
                </select>
            </div>
            <div class="cell_label">
                <label>Game:</label>
            </div>
            <div class="cell_container">
                <select 
                    :value="currentGame"
                    @change="changeGame"    
                >
                    <option value="all">All</option>
                    <option
                        v-for="(gameValue, gameIndex) in games" :key="gameIndex"
                        :value="gameValue.id"
                    >
                        {{ gameValue.name }}
                    </option>
                </select>
            </div>
            <div class="cell_label"></div>
            <div class="cell_container"></div>
        </div>
    </div>
</template>


<style scoped>
    select {
        min-width: 185px;
        max-width: 185px;
        border-radius: 5px;
        border: var(--border);
        padding: 5px;
    }

    .table_row {
        display: flex;
        width: 100%;
        margin-top: 5px;
    }
    .cell_label {
        flex: 0 0 130px;
        margin-right: 10px;
    }
    .cell_container {
        flex: 1 1 185px;
        margin-right: 10px;
    }
</style>